<template>
    <ActivityDetailsCard :activityType="item.type" :title="item.description" />
</template>
<script>
import ActivityDetailsCard from './ActivityDetailsCard.vue'

export default {
    name: 'EmptyActivityDetails',
    components: {
        ActivityDetailsCard,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
}
</script>
